(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    // Desktop hover-intent + Escape handling for the mega menu, plus
  // animated open/close. Native <details>/<summary> click + Enter/Space
  // still work, but its own [open]-attribute toggle is intercepted
  // (preventDefault on the summary click) so every open/close — mouse,
  // keyboard, or hover — goes through open()/close() below and actually
  // animates, instead of the content snapping instantly in and out.
  class MegaMenuEnhancer {
    constructor(headerMenu) {
      this.headerMenu = headerMenu;
      this.details = headerMenu.querySelector('details.mega-menu');
      if (!this.details) return;
      this.summary = this.details.querySelector('summary');
      this.content = this.details.querySelector('.mega-menu__content');
      this.openTimer = null;
      this.closeTimer = null;
      this.closeAnimTimer = null;
      this.CLOSE_DURATION = 350;

      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      headerMenu.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      headerMenu.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.details.addEventListener('keydown', this.onKeydown.bind(this));
    }

    onSummaryClick(event) {
      event.preventDefault();
      if (this.details.hasAttribute('open') && !this.details.classList.contains('mega-menu--closing')) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      window.clearTimeout(this.closeAnimTimer);
      this.details.classList.remove('mega-menu--closing');
      if (!this.details.hasAttribute('open')) {
        this.details.setAttribute('open', '');
        // Force layout so the closed (opacity: 0) state actually paints
        // before the next frame flips it to visible — otherwise the
        // browser can collapse both changes into one frame and the fade
        // never plays.
        this.content.getBoundingClientRect();
      }
      requestAnimationFrame(() => {
        this.details.classList.add('mega-menu--visible');
      });
      this.summary.setAttribute('aria-expanded', 'true');
    }

    close() {
      if (!this.details.hasAttribute('open')) return;
      this.details.classList.remove('mega-menu--visible');
      this.details.classList.add('mega-menu--closing');
      this.summary.setAttribute('aria-expanded', 'false');
      window.clearTimeout(this.closeAnimTimer);
      this.closeAnimTimer = window.setTimeout(() => {
        this.details.removeAttribute('open');
        this.details.classList.remove('mega-menu--closing');
      }, this.CLOSE_DURATION);
    }

    onMouseEnter() {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      window.clearTimeout(this.closeTimer);
      this.openTimer = window.setTimeout(() => {
        this.open();
      }, 150);
    }

    onMouseLeave() {
      window.clearTimeout(this.openTimer);
      if (!this.details.hasAttribute('open')) return;
      this.closeTimer = window.setTimeout(() => {
        this.close();
      }, 500);
    }

    onKeydown(event) {
      if (event.key !== 'Escape' || !this.details.hasAttribute('open')) return;
      this.close();
      this.summary.focus();
    }
  }

  document.querySelectorAll('.header__inline-menu header-menu').forEach((headerMenu) => {
    new MegaMenuEnhancer(headerMenu);
  });
  } catch(e) { console.error(e); }
})();

})();
